// The labels' screen part: its events.
import { defineScreenPart } from "../app/screen-part";
import { invalidateLabels, labelsKey } from "./queries";
import { labelsSettings } from "./settings";

export const labelsPart = defineScreenPart({
  id: "labels",
  settings: [labelsSettings],
  realtime: {
    "label.changed": (_payload, { qc }) => void invalidateLabels(qc),
    "label.removed": (_payload, { qc }) => void invalidateLabels(qc),
  },
  persist: (key) => key[0] === labelsKey[0] && key[1] === labelsKey[1],
});
